export enum PaccsApprovedStatusType {
  Unknown = 0,
  Approved = 1
}
